import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  reVerifyEmail,
  clearVerifyEmailState,
} from "../../redux/Actions/SingleUserActions";
import Storage from "../../utils/storage";
import Loader from "../../components/Loader/Loader";
import Nibss from "../../assets/assets/Nibss-Logo.png";
import Icon from "../../assets/assets/authentication.svg";
import Button from "../../components/Button/Button";
import { PropTypes } from "prop-types";
import { useHistory } from "react-router-dom"
import { authenticateUser } from "../../redux/Actions/LoginActions";
import Alert from "../../utils/Alert";

const AuthenticateUser = ({
  reSending,
  authenticateUser,
  isAuthenticating,
  authenticateUserSuccess,
  reSend,
  reSentSuccess,
  clearVerifyEmailState

}) => {
  const [inputValue, setInputValue] = useState("");
  const history = useHistory();

  const [state, setState] = useState({
    value1: "",
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
  });

  const emailAddress = Storage.get("user-email")

  useEffect(
    () => {
      setInputValue(Object.values(state).join(""));
      if (authenticateUserSuccess) {
        setState({
          ...state,
          inputValue: "",
        });
        clearVerifyEmailState();
      }
    },
    // eslint-disable-next-line
    []
  );

  const updateInputValue = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    setInputValue(Object.values(state).join(""));
  }, [state, inputValue]);

  const verify = () => {
    const codeNo = {
      code: inputValue,
      email: emailAddress
    };
    authenticateUser(codeNo, history);
  };

  const reSendCode = () => {
    const email = {
      email: emailAddress,
      type: "two_factor"
    };
    reSend(email);
  };

  useEffect(() => {
    if (reSentSuccess) {
      Alert(
        true,
        "success",
        "success message",
        "A new verification email has been successfully sent to your email."
      );
    }
  },
  // eslint-disable-next-line
  [reSentSuccess]);

  const moveOnMax = (field, nextId) => {
    if (field.length >= 1) {
      document.getElementById(nextId).focus();
    }
  };

  return (
    <div className="wrapper">
      <div className="verification-logo">
        <img src={Nibss} alt="logo" />
      </div>
      <div className="body-wrap">
        <div className="mail">
          <img src={Icon} alt="auth-icon" />
        </div>
        <>
          <div className="verification-text">
            <p className="verification-text-header">
              Two Factor Authentication
              </p>
            <p className="verification-text-paragraph">
              A code has been sent to {emailAddress}, please check your inbox
                and insert the 6 digit code in the form below to authenticate your
                login
            </p>
          </div>
          <div className="verification-input-wrap">
            <input
              className="verification-input"
              type="text"
              pattern="/^-?\d*$/"
              maxLength="1"
              name="value1"
              value={state.value1}
              id="one"
              onChange={updateInputValue}
              onKeyUp={() => moveOnMax(state.value1, "two")}
            />

            <input
              className="verification-input"
              type="text"
              pattern="/^-?\d*$/"
              maxLength="1"
              name="value2"
              value={state.value2}
              onChange={updateInputValue}
              id="two"
              onKeyUp={() => moveOnMax(state.value2, "three")}
            />

            <input
              className="verification-input"
              type="text"
              pattern="/^-?\d*$/"
              maxLength="1"
              name="value3"
              value={state.value3}
              id="three"
              onChange={updateInputValue}
              onKeyUp={() => moveOnMax(state.value3, "four")}
            />

            <input
              className="verification-input"
              type="text"
              pattern="/^-?\d*$/"
              maxLength="1"
              name="value4"
              value={state.value4}
              id="four"
              onChange={updateInputValue}
              onKeyUp={() => moveOnMax(state.value4, "five")}
            />

            <input
              className="verification-input"
              type="text"
              pattern="/^-?\d*$/"
              maxLength="1"
              name="value5"
              value={state.value5}
              id="five"
              onChange={updateInputValue}
              onKeyUp={() => moveOnMax(state.value5, "six")}
            />

            <input
              className="verification-input"
              type="text"
              pattern="/^-?\d*$/"
              maxLength="1"
              name="value6"
              value={state.value6}
              id="six"
              onChange={updateInputValue}
            />
          </div>
          <div className="verification-confirmation">
            {reSending ?
              <span className="verification-confirmation-text">
                Resending...
                </span>
              : (
                <span className="verification-confirmation-text">
                  Didn’t get the code?
                  <span id="resend" onClick={() => reSendCode()}>
                    {" "}resend
                </span>
                </span>
              )}

            <Button
              width="200px"
              word={isAuthenticating ? <Loader /> : "CONTINUE"}
              disabled={
                isAuthenticating || inputValue === "" || inputValue.length !== 6
              }
              onClick={() => verify()}
            />
          </div>
        </>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticating: state.auth.isAuthenticating,
    currentUser: state.auth.currentUser,
    reSending: state.singleUser.reVerifying,
    reSentSuccess: state.singleUser.reVerifiedEmail,
    reSentCode: state.singleUser.reVerificationStatus,
    authenticateUserSuccess: state.auth.authenticateUserSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  authenticateUser: (payload, history) => dispatch(authenticateUser(payload, history)),
  reSend: (payload) => dispatch(reVerifyEmail(payload)),
  clearVerifyEmailState: () => dispatch(clearVerifyEmailState())
});

AuthenticateUser.propTypes = {
  authenticateUser: PropTypes.func,
  authenticateUserSuccess: PropTypes.bool,
  clearVerifyEmailState: PropTypes.func,
  isAuthenticating: PropTypes.bool,
  reSend: PropTypes.func,
  reSending: PropTypes.bool,
  reSentSuccess: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticateUser);